import React from 'react';
import './PageLoader.css';

/**
 * Skeleton shown while a route chunk loads. Mirrors the standard
 * page layout: eyebrow, headline, copy, actions, card row.
 */
const PageLoader = () => (
    <div className="page-loader" role="status" aria-label="Loading page">
        <div className="page-loader-inner">
            <span className="skeleton skeleton-eyebrow" />
            <span className="skeleton skeleton-title" />
            <span className="skeleton skeleton-line" />
            <span className="skeleton skeleton-line skeleton-line-short" />
            <span className="skeleton skeleton-pill" />
            <div className="page-loader-cards">
                <span className="skeleton skeleton-card" />
                <span className="skeleton skeleton-card" />
                <span className="skeleton skeleton-card" />
            </div>
        </div>
    </div>
);

export default PageLoader;
